module.exports = __webpack_public_path__ + "assets/img/12-l.9172527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/12-l.jpg
// module id = dR3f
// module chunks = 0